var _desc, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Github") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.281 16.531a11 11 0 0 0-7.688 3 10.213 10.213 0 0 0-3.375 7.875 10.026 10.026 0 0 0 1.875 5.906 7.286 7.286 0 0 0 3.75 3.281v.094c-1.5.656-2.156 2.156-2.156 4.594a4.574 4.574 0 0 0 2.157 4.219v.094c-4.125 1.312-6 3.844-6 7.594a7.524 7.524 0 0 0 4.125 7.031A15.944 15.944 0 0 0 17.125 62c8.063 0 12.188-3.375 12.188-10.219 0-4.219-3.094-6.844-9.375-7.781a5.2 5.2 0 0 1-3.281-1.594 2.431 2.431 0 0 1-.844-1.687c0-1.594.844-2.531 2.625-2.812A9.843 9.843 0 0 0 25 34.156a11.191 11.191 0 0 0 2.531-7.312 8.637 8.637 0 0 0-.656-2.812 14.23 14.23 0 0 0 2.531-.75v-6.75a20.184 20.184 0 0 1-7.219 1.594 11.87 11.87 0 0 0-5.906-1.595zm.75 32.813c3.656 0 5.531 1.125 5.531 3.375 0 2.344-1.688 3.562-5.063 3.562-3.844 0-5.813-1.125-5.813-3.375.001-2.437 1.783-3.562 5.345-3.562zM16.563 32c-2.719 0-4.125-1.5-4.125-4.5 0-3.281 1.406-4.875 4.125-4.875a3.578 3.578 0 0 1 3.094 1.5 5.418 5.418 0 0 1 .938 3.281C20.594 30.5 19.187 32 16.563 32zM36.531 2a4.4 4.4 0 0 0-3.281 1.406 4.731 4.731 0 0 0-1.312 3.469 4.912 4.912 0 0 0 1.312 3.375 4.4 4.4 0 0 0 3.281 1.406 4.345 4.345 0 0 0 3.188-1.406 4.519 4.519 0 0 0 1.313-3.375 5.146 5.146 0 0 0-1.313-3.469A4.345 4.345 0 0 0 36.531 2zm3.657 15h-7.407c.094.844 0 2.156 0 4.125v20.438c0 2.062.094 3.75 0 4.5h7.406a45.132 45.132 0 0 1-.281-4.875V21.031A31.772 31.772 0 0 1 40.188 17z",
    fill: "none",
    stroke: "#04609C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 39.781c-1.969 0-2.906-1.5-2.906-4.406V23.281h5.625V17h-5.625v-2.812a17.288 17.288 0 0 1 .281-2.625h-7.594a20.55 20.55 0 0 1 .094 2.719V17h-3.281v6.281c.938-.094 1.687-.188 2.25-.188l1.031.094V35c0 3.656.469 6.375 1.406 8.062 1.219 2.25 3.375 3.375 6.563 3.375a12.108 12.108 0 0 0 5.813-1.312v-6.562a5.734 5.734 0 0 1-3.657 1.218z",
    fill: "none",
    stroke: "#E8AD5A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGit);
export default __webpack_public_path__ + "static/media/icon-git.349b2d3feda508b14870c85c1957f063.svg";
export { ForwardRef as ReactComponent };